import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import {
  HeaderContainer,
  BackButton,
  HeaderContent,
  PageTitle,
  PageSubtitle,
} from "./styles";

const TrendingItemsHeader: React.FC = () => {
  const navigate = useNavigate();

  return (
    <HeaderContainer>
      <BackButton
        icon={<FontAwesomeIcon icon={faArrowLeft} />}
        onClick={() => navigate(-1)}
        shape="circle"
        size="large"
        aria-label="Go Back to Analytics Dashboard"
      />
      <HeaderContent>
        <PageTitle level={2}>Trending Items Analysis</PageTitle>
        <PageSubtitle>
          Track trending menu items and their growth patterns
        </PageSubtitle>
      </HeaderContent>
    </HeaderContainer>
  );
};

export default TrendingItemsHeader;
